import React, { Component } from 'react';

import { SectionTitle, SectionDescription, BoxContentIcon }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';

const desc = "A RAD é uma fornecedora global de soluções e produtos de acesso de telecomunicações.";  

class PageInternalRad extends Component {
    render() {
        return (
            <section className={ isMobile ? 'page-internal-mobile' : 'page-internal'} id="page" >
                <div className="container">
                    {SectionTitle({section: 'RAD', subtitle:'CONHEÇA A', featured: 'RAD'})}
                    {SectionDescription(desc)}   
                    <div className="mt-50">&nbsp;</div>   
                    {SectionTitle({section: 'Produtos', subtitle:'PRINCIPAIS', featured: 'PRODUTOS E APLICAÇÕES'})}
                    
                    <h4>Rádio ponto a ponto frequência livre</h4>
                    <div className="row">                    
                        <div className="col-12 col-md-4">
                            <img src={process.env.PUBLIC_URL + '/assets/images/Airmux-400.jpg'} alt="Airmux-400" className="logo-internal" className="img-fluid" /> 
                        </div>
                        <div className="col-12 col-md-8">
                            <h5>Airmux-400</h5>  
                            <p className="align-left">Controle e monitoramento de infraestrutura de missão crítica.</p>      
                            <ul>
                                <li>A série Airmux-400 da RAD de rádios sem fio de banda larga ponto a ponto oferece os serviços Ethernet e TDM nativos em um único link sem fio em várias frequências abaixo de 6 GHz;</li>
                                <li>Com uma combinação flexível de Ethernet e até 16 interfaces E1/T1, os sistemas de rádio Airmux-400 de alta capacidade fornecem taxa de transferência agregada de até 750 Mbps e alcance de até 120 km.</li>
                            </ul>                            
                        </div>
                        <div className="col-12">
                            <hr/>
                        </div>                        
                    </div>
                    
                    <h4>Rádio Ponto-Multiponto</h4>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <img src={process.env.PUBLIC_URL + '/assets/images/Airmux-5000.jpg'} alt="Airmux-5000" className="logo-internal" className="img-fluid" /> 
                        </div>
                        <div className="col-12 col-md-8">
                            <h5>AIRMUX-5000</h5>  
                            <ul>
                                <li>Os rádios sem fio de banda larga ponto a multiponto Airmux-5000 da RAD são ideais para soluções de usuários corporativos que exigem alta capacidade de processamento com tráfego dedicado, alocação de largura de banda e nível de serviço (SLA) por assinante;</li>
                                <li>Com capacidade setorial agregada de até 750 Mbps e alcance de até 40 km, uma única estação base Airmux-5000 suporta até 64 unidades de assinantes remotas (SUs) com operação multibanda, sendo ideal para:</li>
                                <li>Provedores de serviços e ISPs, oferecendo backhaul de IP e acesso 4G/banda larga para comunidades remotas, rurais e carentes;</li>
                                <li>Redes privadas que exigem conectividade entre filiais de alta capacidade para campi universitários, organizações de saúde, instituições governamentais, grandes empresas e estabelecimentos públicos;</li>
                                <li>Aplicativos de segurança e vigilância que demandam agregação e backhaul de tráfego de várias câmeras HD.</li>                                
                            </ul>                            
                        </div>
                        <div className="col-12">
                            <hr/>
                        </div>                        
                    </div>
                    
                    <h4>Acesso a multisserviços de última geração</h4>
                    <p>Solução para operadoras e provedores, através do ajuste perfeito para grandes empresas, serviços públicos e privados, que exigem uma maneira eficiente para transportar e fornecer múltiplos legados e serviços de última geração.</p>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <img src={process.env.PUBLIC_URL + '/assets/images/Megaplex-4.jpg'} alt="Megaplex-4" className="logo-internal" className="img-fluid" /> 
                        </div>
                        <div className="col-12 col-md-8">
                            <h5>Megaplex-4100</h5>  
                            <p>Como um nó de acesso e multisserviço, o Megaplex-4100 fornece solução eficiente e econômica para integração de várias interfaces, taxas de dados e usuários serviços. As interfaces disponíveis e o número máximo de portas por chassi são:</p>
                            <ul>
                                <li>4 portas STM-4 / OC-12 ou STM-1 / OC-3 (duas portas por módulo CL.2)</li>
                                <li>4 portas GbE (duas portas por CL.2 módulo)</li>
                                <li>160 portas E1 / T1</li>
                                <li>80 portas SHDSL</li>
                                <li>20 links de fibra para TDM multiplexado e Tráfego Ethernet</li>
                                <li>30 portas Fast Ethernet</li>
                                <li>120 n x 64 kbps</li>
                                <li>120 portas de dados de taxa sub-DS0</li>
                                <li>160 portas de voz analógicas.</li>                                
                            </ul>     
                            <p>Além disso, o Megaplex-4100 pode trabalhar com dispositivos específicos da indústria, como Unidades de Teleproteção e Omnibus</p>
                        </div>
                        <div className="col">
                                <h5>Figura de Apoio Megaplex-4100</h5>  
                        </div>                            
                        <div className="col-md-12">
                            <center>
                                <img src={process.env.PUBLIC_URL + '/assets/images/Megaplex-4-apoio.jpg'} alt="Megaplex-4" className="img-fluid"/> 
                            </center>
                        </div>
                        <div className="col-md-12">
                            <center>
                                <img src={process.env.PUBLIC_URL + '/assets/images/Operational-Network-Power.gif'} alt="Operational-Network-Power" className="img-fluid"/> 
                            </center>
                        </div>
                        <div className="col-12">
                            <hr/>
                        </div>                        
                    </div>

                </div>
            </section>
        )
    }
}

export default PageInternalRad;
